import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';

import {
	TaskActionsComponent,
	TaskActionsDialogComponent,
} from './task-actions/task-actions.component';
import { TaskComponent, TaskDialog } from './task/task.component';
import { TasksInfiniteScrollComponent } from './tasks-infinite-scroll/tasks-infinite-scroll.component';
import { TasksIconComponent } from './tasks-icon/tasks-icon.component';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';

const components = [
	TaskActionsComponent,
	TaskActionsDialogComponent,
	TaskComponent,
	TaskDialog,
	TasksInfiniteScrollComponent,
	TasksIconComponent,
];

@NgModule({
	declarations: [...components],
	imports: [CommonModule, CoreModule, SharedModule, MtxPopoverModule],
	exports: [...components],
})
export class CoreTasksModule {}
